export const REDUX_PLUS_LOAD_EXCEPTION_MODAL_STORE_KEY = 'plusLoadExceptionModalStore'

export interface PlusLoadExceptionModalStore {
  open: boolean,
  status: PlusLoadExceptionModalStatus,
}

const createDefaultState = (): PlusLoadExceptionModalStore => ({
  open: false,
  status: PlusLoadExceptionModalStatus.TOO_LATE,
})

export enum PlusLoadExceptionModalActions {
  OPEN_PLUS_LOAD_EXCEPTION_MODAL_TOO_LATE = 'OPEN_PLUS_LOAD_EXCEPTION_MODAL_TOO_LATE',
  OPEN_PLUS_LOAD_EXCEPTION_MODAL_SUBMITTED_OR_APPLIED = 'OPEN_PLUS_LOAD_EXCEPTION_MODAL_SUBMITTED_OR_APPLIED',
  CLOSE_PLUS_LOAD_EXCEPTION_MODAL = 'CLOSE_PLUS_LOAD_EXCEPTION_MODAL',
}

export const PlusLoadExceptionModalAction = {
  openTooLate: () => ({ type: PlusLoadExceptionModalActions.OPEN_PLUS_LOAD_EXCEPTION_MODAL_TOO_LATE }),
  openPlusLoadSubmittedOrApplied: () => ({ type: PlusLoadExceptionModalActions.OPEN_PLUS_LOAD_EXCEPTION_MODAL_SUBMITTED_OR_APPLIED }),
  close: () => ({ type: PlusLoadExceptionModalActions.CLOSE_PLUS_LOAD_EXCEPTION_MODAL }),
}

export enum PlusLoadExceptionModalStatus {
  TOO_LATE,
  SUBMITTED_OR_APPLIED,
}

interface Action {
  type: PlusLoadExceptionModalActions,
}

const createPlusLoadExceptionModalStoreReducer = () => (state: PlusLoadExceptionModalStore = createDefaultState(), action: Action): PlusLoadExceptionModalStore => {
  switch (action.type) {
    case PlusLoadExceptionModalActions.OPEN_PLUS_LOAD_EXCEPTION_MODAL_TOO_LATE: {
      return {
        ...state,
        status: PlusLoadExceptionModalStatus.TOO_LATE,
        open: true,
      }
    }
    case PlusLoadExceptionModalActions.OPEN_PLUS_LOAD_EXCEPTION_MODAL_SUBMITTED_OR_APPLIED: {
      return {
        ...state,
        status: PlusLoadExceptionModalStatus.SUBMITTED_OR_APPLIED,
        open: true,
      }
    }
    case PlusLoadExceptionModalActions.CLOSE_PLUS_LOAD_EXCEPTION_MODAL: {
      return {
        ...state,
        open: false,
      }
    }
    default: {
      return state
    }
  }
}


export default createPlusLoadExceptionModalStoreReducer
